import React, { useMemo } from "react";
import { Formik } from "formik";
import { isEqual } from "lodash";
import { useNotificationTemplateUIContext } from "../../NotificationTemplateUIContext";
import {
  initialFilter,
  NOTIFICATION_TYPE_ARRAY
} from "../../NotificationTemplateUIHelpers";
import ReactSelect, { components } from "react-select";
import {
  IS_ACTIVE,
  ORGANIZATION_STATUS_OPTION
} from "../../../../../../config/helper";

const prepareFilter = (queryParams, values) => {
  const { name, type, is_active } = values;
  const newQueryParams = { ...queryParams };
  const filter = {};

  //add to Object filter
  filter.name = name ?? "";
  filter.type = type ?? "";
  filter.is_active = is_active ?? "";
  newQueryParams.filter = filter;
  return newQueryParams;
};

export const NotificationTemplateFilter = ({ listLoading }) => {
  // NotificationTemplate UI Context
  const notificationTemplateUIContext = useNotificationTemplateUIContext();
  const notificationTemplateUIProps = useMemo(() => {
    return {
      setQueryParams: notificationTemplateUIContext.setQueryParams,
      queryParams: notificationTemplateUIContext.queryParams,
      filterType: notificationTemplateUIContext.filterType
    };
  }, [notificationTemplateUIContext]);

  const applyFilter = values => {
    const newQueryParams = prepareFilter(
      notificationTemplateUIProps.queryParams,
      values
    );
    if (!isEqual(newQueryParams, notificationTemplateUIProps.queryParams)) {
      newQueryParams.pageNumber = 1;
      notificationTemplateUIProps.setQueryParams(newQueryParams);
    }
  };

  return (
    <Formik
      initialValues={initialFilter.filter}
      onSubmit={values => {
        applyFilter(values);
      }}
    >
      {({ values, handleSubmit, handleBlur, setFieldValue }) => (
        <form onSubmit={handleSubmit} className="form form-label-right">
          <div className="form-group row">
            <div className="col-lg-4">
              <label htmlFor="name">Nama</label>
              <input
                type="text"
                className="form-control"
                name="name"
                placeholder="Lembaga A"
                onBlur={handleBlur}
                value={values.name}
                onChange={e => {
                  setFieldValue("name", e.target.value);
                }}
              />
            </div>
            <div className="col-lg-4">
              <label htmlFor="type">Tipe</label>
              <ReactSelect
                name="type"
                options={NOTIFICATION_TYPE_ARRAY.map(item => ({
                  label: item.label,
                  value: item.value
                }))}
                value={
                  values.type
                    ? {
                        label: values.type,
                        value: values.type
                      }
                    : null
                }
                isClearable
                onChange={e => {
                  const value = e && e.value;
                  if (value) {
                    setFieldValue("type", value);
                  } else {
                    setFieldValue("type", null);
                  }
                }}
              />
            </div>
            {/* <div className="col-lg-4">
              <label htmlFor="is_active">Status Aktif</label>
              <ReactSelect
                name="is_active"
                options={IS_ACTIVE.map(item => ({
                  label: item.label,
                  value: item.value
                }))}
                value={{
                  label: values.is_active_label,
                  value: values.is_active
                }}
                isClearable
                onChange={e => {
                  const value = e && e.value;
                  const label = e && e.label;
                  setFieldValue("is_active_label", label);
                  setFieldValue("is_active", value);
                  // if (value) {
                  // } else {
                  //   setFieldValue("is_active", false);
                  // }
                }}
              />
            </div> */}
          </div>
          <div className="form-group row">
            <div className="col">
              <button
                className="btn btn-warning float-right"
                onClick={handleSubmit}
              >
                Terapkan
              </button>
            </div>
          </div>
        </form>
      )}
    </Formik>
  );
};
